import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { createQuery } from '@farfetched/core';
import { getIntercomModels } from './api';
import type { GetIntercomModelsResponse } from './types';

export const IntercomModelsControlGate = createGate<void>();

const fxGetIntercomModels = createEffect<void, GetIntercomModelsResponse, Error>().use(
  getIntercomModels
);

export const intercommodelsQuery = createQuery({
  name: 'IntercomModels',
  effect: fxGetIntercomModels,
  mapData: ({ result }) =>
    Array.isArray(result?.model)
      ? result.model.map(({ id, title }) => ({ id, label: title ?? '' }))
      : [],
});

sample({
  clock: IntercomModelsControlGate.open,
  source: IntercomModelsControlGate.status,
  filter: (status) => Boolean(status),
  target: intercommodelsQuery.start,
});
